function checkImagesLoaded(container = document) {
  const images = container.querySelectorAll('img.track-loaded');

  images.forEach((image) => {
    if (image.complete) {
      image.classList.add('is-complete');
    } else {
      image.addEventListener('load', () => {
        image.classList.add('is-complete');
      });
    }
  });
}

checkImagesLoaded();

document.addEventListener('shopify:section:load', () => {
  checkImagesLoaded();
});

document.addEventListener('switch:load:images', (e) => {
  const container = e.detail && e.detail.container ? e.detail.container : document;
  checkImagesLoaded(container);
});

function repairMatteoWhatsappLinks(container = document) {
  const malformedPrefix = `${window.location.origin}/products/https%3A%2F%2Fwa.me%2F`;

  container.querySelectorAll('a[href*="wa.me"], a[href*="https%3A%2F%2Fwa.me"]').forEach((link) => {
    const href = link.getAttribute('href') || '';
    const absoluteHref = link.href || href;

    if (href.startsWith('https://wa.me/')) return;

    if (absoluteHref.startsWith(malformedPrefix)) {
      const encodedTarget = absoluteHref.slice(`${window.location.origin}/products/`.length);
      link.href = decodeURIComponent(encodedTarget);
    }
  });
}

repairMatteoWhatsappLinks();
document.addEventListener('DOMContentLoaded', () => repairMatteoWhatsappLinks());
document.addEventListener('shopify:section:load', (event) => repairMatteoWhatsappLinks(event.target));
